// extracted by mini-css-extract-plugin
export default {"title":"Projects_title__dF5-F","container":"Projects_container__IarhK","projects":"Projects_projects__s9S0V","project":"Projects_project__7TPXp"};